import axios from 'axios'

const RESET = 'RESET'
const SET_TENANT_APPROVAL_LEVEL_CONFIGURATIONS = 'SET_TENANT_APPROVAL_LEVEL_CONFIGURATIONS'
const SET_SYSTEM_DEFAULT_APPROVAL_LEVEL_CONFIGURATIONS = 'SET_SYSTEM_DEFAULT_APPROVAL_LEVEL_CONFIGURATIONS'
const SET_LOADING_STATE = 'SET_LOADING_STATE'
const URL_tenantApprovalConfiguration = 'api/ContinuousApprovalLevel'
const URL_defaultApprovalConfiguration = 'api/ContinuousApprovalLevel/Default'

function initialState() {
  return {
    tenantApprovalLevelConfigurations: [],
    systemDefaultApprovalLevelConfigurations: [],
    isLoading: false,
  }
}

export default {
  namespaced: true,
  state: initialState,
  actions: {
    async getTenantApprovalLevelConfigurations({ commit }, { tenantId }) {
      commit(SET_LOADING_STATE, true)
      try {
        let res = await axios.get(URL_tenantApprovalConfiguration, { params: { tenantId } })
        let data = (res && res.data) || []
        commit(SET_TENANT_APPROVAL_LEVEL_CONFIGURATIONS, data)
      } finally {
        commit(SET_LOADING_STATE, false)
      }
    },
    async upsertTenantApprovalLevelConfiguration(_, { configuration }) {
      await axios.put(URL_tenantApprovalConfiguration, configuration)
    },
    async deleteTenantApprovalLevelConfiguration(_, { configuration }) {
      await axios.delete(URL_tenantApprovalConfiguration, { data: configuration })
    },
    async getSystemDefaultApprovalLevelConfigurations({ commit }, { continuousDatabaseType }) {
      commit(SET_LOADING_STATE, true)
      try {
        let res = await axios.get(URL_defaultApprovalConfiguration, { params: { continuousDatabaseType } })
        let data = (res && res.data) || []
        commit(SET_SYSTEM_DEFAULT_APPROVAL_LEVEL_CONFIGURATIONS, data)
      } finally {
        commit(SET_LOADING_STATE, false)
      }
    },
    async upsertSystemDefaultApprovalLevelConfiguration({ commit }, { continuousDatabaseType, configuration }) {
      await axios.put(URL_defaultApprovalConfiguration, configuration, { params: { continuousDatabaseType } })
    },
    async deleteSystemDefaultApprovalLevelConfiguration({ commit }, { continuousDatabaseType, configuration }) {
      await axios.delete(URL_defaultApprovalConfiguration, { params: { continuousDatabaseType }, data: configuration })
    },
  },
  mutations: {
    [RESET](state) {
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
    [SET_TENANT_APPROVAL_LEVEL_CONFIGURATIONS](state, approvalLevelConfigurations) {
      state.tenantApprovalLevelConfigurations = approvalLevelConfigurations
    },
    [SET_SYSTEM_DEFAULT_APPROVAL_LEVEL_CONFIGURATIONS](state, approvalLevelConfigurations) {
      state.systemDefaultApprovalLevelConfigurations = approvalLevelConfigurations
    },
    [SET_LOADING_STATE](state, isLoading) {
      state.isLoading = isLoading
    },
  },
  getters: {},
}